import { IconDefinition } from "@fortawesome/free-solid-svg-icons"
import { PaginationQuery, PaginationQueryDefaultValues } from "../pagination/pagination-query"
import { faHeart as faHeartUnchecked } from '@fortawesome/free-regular-svg-icons';
import { TagList, TagListDefaultValues } from "../tags/tag-list";

export interface ParticipantCourseList{
    courseRecordId: string,
    courseId: string,
    courseName: string,
    courseShortDescription: string,
    courseDescription: string,
    tags: TagList[],
    courseThumbnailIconId: number,
    thumbnailUrl: string,
    enrollmentStatus: string,
    enrollmentClass: string,
    retired: boolean,
    language: string,
    favoriteFlag: boolean,
    favoriteIcon: IconDefinition,
    courseType:number
}

export function ParticipantCourseListDefaultValues(): ParticipantCourseList
{
    return {
      courseRecordId: '',
      courseId: '',
      courseName: '',
      courseShortDescription: '',
      courseDescription: '',
      tags: [TagListDefaultValues()],
      courseThumbnailIconId: 0,
      thumbnailUrl: '',
      enrollmentStatus: '',
      enrollmentClass: '',
      retired: false,
      favoriteFlag: false,
      favoriteIcon: faHeartUnchecked,
      language: '',
      courseType:0
    }
}

export type ParticipantCourseQueryFilter = PaginationQuery & {
    CourseKeyword: string,
    CourseProgram: number,
    Tag: number,
    CourseStatus: number,
    ParticipantCourseEnrollmentStatus: any[],
    ParticipantCourseTags: any[],
    CourseLanguage: number
}

export function ParticipantCourseQueryFilterDefaultValues(): ParticipantCourseQueryFilter
{
    return {
      ...PaginationQueryDefaultValues(),
      CourseKeyword: '',
      CourseProgram: 0,
      Tag: 0,
      CourseStatus: 0,
      ParticipantCourseEnrollmentStatus: [],
      ParticipantCourseTags: [],
      CourseLanguage: 1
    }
}

